module.exports = __webpack_public_path__ + "img/ic_cotações_azul.7e123231.svg";